export const iconFontAwesomeConstructionDumpsterFire = (
	<i className="fa-solid fa-dumpster-fire"></i>
);
